// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"ae755b0a","94":"7e2e27c8","213":"bf9f5c0f","372":"8802867b","395":"f0f33e23","411":"82a32438","471":"f4c4b43e","477":"5eaf27ec","517":"56e28904","706":"8f2f5279","822":"d691785b"}[chunkId] + ".chunk.js";
};